export default {"src":"https://fishbrain.com/_next/static/media/sunfish.147220fd.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};